import React, { Component } from "react";
import Auth from "../Auth";
import { Link } from "react-router-dom";
import { authMode } from "../security/http";
import { canAccessRoute } from "../security/routes";
import { getPaymentsPath } from "./payments/PaymentTabs";
import { getSettingsPath } from "./SystemSettings/SettingsTabs";
class Siderbar extends Component {
  
  redirect = () => {
    const { history } = this.props;
    if (history) history.push("/");
  };

  logout() {
    Auth.SignOut();
  }

  handleLogOut = async (e) => {
    e.preventDefault();
    await Auth.SignOut();
    this.redirect();
    window.location.reload();
  };
  render() {
    const allowed = (page) => canAccessRoute(`/Main/${page}`);
    const paymentsPath = getPaymentsPath();
    const settingsPath = getSettingsPath();
    return (
      <div>
        {" "}
        <nav className="sidebar-wrapper">
          <div className="sidebar-brand d-flex" id="sidebar">
            {/* <span className="logdashboard">IKIMINA MANAGEMENT</span> */}
            <Link to="/" className="logdashboard">
              IKIMINA MANAGEMENT
            </Link>
          </div>

          <div
            className="slimScrollDiv"
            style={{
              position: "relative",
              overflowY: "hidden",
              width: "auto",
              height: " 100%",
            }}
          >
            <div className="Nav_right">
              <ul className="ullinks ">
                {authMode() !== "legacy" && <li className="Nav__item">
                  <Link className="Nav__link" to="/Main/MyMembership">My Membership</Link>
                </li>}
                {allowed("Overall") && <li className="Nav__item">
                  {/* <span>
                    <i class="fas fa-columns"></i>
                  </span> */}

                  <Link className="Nav__link " to="/Main/Overall">
                    Overview
                  </Link>
                </li>}
                {/* <li className="Nav__item"> */}
                {/* <span>
                    <i class="fas fa-user-edit"></i>
                  </span> */}
                {/* <Link className="Nav__link " to="/Main/Members">
                    Users
                  </Link>
                </li> */}

                {allowed("RoundInfo") && <li className="Nav__item">
                  {/* <span>
                    <i class="fas fa-money-bill-alt"></i>
                  </span> */}
                  <Link className="Nav__link " to="/Main/RoundInfo">
                    Rounds
                  </Link>
                </li>}
                {allowed("Allloans") && <li className="Nav__item">
                  {/* <span>
                    <i class="fas fa-money-bill-alt"></i>
                  </span> */}
                  <Link className="Nav__link " to="/Main/Allloans">
                    Loan
                  </Link>
                </li>}

                {paymentsPath && <li className="Nav__item">
                  {/* <span>
                    <i class="fas fa-money-bill-alt"></i>
                  </span> */}
                  <Link className="Nav__link " to={paymentsPath}>
                    Payments
                  </Link>
                </li>}
                {allowed("IncomeReport") && <li className="Nav__item">
                  {/* <span>
                    <i class="fas fa-money-bill-alt"></i>
                  </span> */}
                  <Link className="Nav__link " to="/Main/IncomeReport">
                    Reports
                  </Link>
                </li>}
                {allowed("Myapproval") && <li className="Nav__item">
                  {/* <span>
                    <i class="fas fa-money-bill-alt"></i>
                  </span> */}
                  <Link className="Nav__link " to="/Main/Myapproval">
                    Requests
                  </Link>
                </li>}
                {settingsPath && <li className="Nav__item">
                  {/* <span>
                    <i class="fas fa-money-bill-alt"></i>
                  </span> */}
                  <Link className="Nav__link " to={settingsPath}>
                    System Settings
                  </Link>
                </li>}
              </ul>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

export default Siderbar;
